import { render } from "./CoordinateDataAdd.vue?vue&type=template&id=66bfd6a1"
import script from "./CoordinateDataAdd.vue?vue&type=script&lang=js"
export * from "./CoordinateDataAdd.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "66bfd6a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66bfd6a1', script)) {
    api.reload('66bfd6a1', script)
  }
  
  module.hot.accept("./CoordinateDataAdd.vue?vue&type=template&id=66bfd6a1", () => {
    api.rerender('66bfd6a1', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/CoordinateData/CoordinateDataAdd.vue"

export default script